import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
});

// Inject auth token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('ops_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ops_token');
      localStorage.removeItem('ops_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const opsLogin = (email, password) => api.post('/auth/ops/login', { email, password });

// Alerts
export const getAlerts = (params) => api.get('/alerts', { params });
export const getAlert = (id) => api.get(`/alerts/${id}`);
export const updateAlertStatus = (id, status, notes) => api.patch(`/alerts/${id}/status`, { status, notes });
export const dispatchTeam = (alertId, data) => api.post(`/alerts/${alertId}/dispatch`, data);

// Teams
export const getTeams = () => api.get('/teams');
export const createTeam = (data) => api.post('/teams', data);
export const getTeamPersonnel = (teamId) => api.get(`/teams/${teamId}/personnel`);

// Personnel
export const getPersonnel = () => api.get('/personnel/all');
export const createPersonnel = (data) => api.post('/personnel/create', data);
export const updatePersonnelStatus = (id, is_available) => api.patch(`/personnel/${id}/status`, { is_available });

// Roster
export const getRoster = (params) => api.get('/roster', { params });
export const createShift = (data) => api.post('/roster', data);

// Categories
export const getCategories = () => api.get('/categories');

export default api;
